import { Observable, throwError } from "rxjs";
import { ApiException } from "@api";
import { addDays, addMonths } from "date-fns";
import { PeriodRange } from "../api/proxies";

export function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = function () {
                observer.next(this.result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}

export function throwException(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result?: any
): Observable<any> {
    if (result !== null && result !== undefined) return throwError(result);
    else return throwError(new ApiException(message, status, response, headers, null));
}
export class SessionHelper {
    static PeriodConverter(period: number): PeriodRange {
        const now = new Date();
        let from: Date;
        let to: Date;

        switch (period) {
            //Últimos 7 dias (até 1 semana)
            case 1:
                from = addDays(now, -7);
                to = now;
                break;

            //De 8 a 14 dias (1 a 2 semanas)
            case 2:
                from = addDays(now, -14);
                to = addDays(now, -8);
                break;

            //De 15 a 30 dias (2 semanas a 1 mês)
            case 3:
                from = addDays(now, -30);
                to = addDays(now, -15);
                break;

            //De 31 a ~180 dias (1 a 6 meses)
            case 4:
                from = addMonths(now, -6);
                to = addDays(now, -31);
                break;

            //Mais de 6 meses (> 180 dias)
            case 5:
                from = new Date(0);
                to = addMonths(now, -6);
                break;

            default:
                // nenhum filtro
                from = new Date(0);
                to = now;
        }

        return new PeriodRange({ from, to });
    }
}